// extracted by mini-css-extract-plugin
module.exports = {"payment-method-title":"styles_payment-method-title__w7_XX","streamlined-payment-method":"styles_streamlined-payment-method__RFAPu"};